export enum LocationType {
  Unknown = 0,
  FedEx = 1,
  FedExButthead = 2,
  Potential = 10,
  FedExParking = 20,
  Gas = 21,
  Mechanic = 22,
  RestStop = 23,
  Other = 100,
  Road = 101,
  //Political
  State = 200
}

export const LocationTypeMapping: Record<LocationType, string> = {
  [LocationType.Unknown]: 'Unknown',
  [LocationType.FedEx]: 'FedEx',
  [LocationType.FedExButthead]: 'FedEx Butthead',
  [LocationType.Potential]: 'Potential',
  [LocationType.FedExParking]: 'FedEx Parking',
  [LocationType.Mechanic]: 'Mechanic',
  [LocationType.RestStop]: 'Rest Stop',
  [LocationType.Other]: 'Other',
  [LocationType.Road]: 'Road',
  [LocationType.Gas]: 'Gas',
  [LocationType.State]: 'State'
};
